import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// src/index.ts
import { useCallbackRef } from "@chakra-ui/react-use-callback-ref";
import { useCallback, useState, useId } from "react";
function useDisclosure() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onCloseProp = props.onClose,
    onOpenProp = props.onOpen,
    isOpenProp = props.isOpen,
    idProp = props.id;
  var handleOpen = useCallbackRef(onOpenProp);
  var handleClose = useCallbackRef(onCloseProp);
  var _useState = useState(props.defaultIsOpen || false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenState = _useState2[0],
    setIsOpen = _useState2[1];
  var isOpen = isOpenProp !== void 0 ? isOpenProp : isOpenState;
  var isControlled = isOpenProp !== void 0;
  var uid = useId();
  var id = idProp !== null && idProp !== void 0 ? idProp : "disclosure-".concat(uid);
  var onClose = useCallback(function () {
    if (!isControlled) {
      setIsOpen(false);
    }
    handleClose == null ? void 0 : handleClose();
  }, [isControlled, handleClose]);
  var onOpen = useCallback(function () {
    if (!isControlled) {
      setIsOpen(true);
    }
    handleOpen == null ? void 0 : handleOpen();
  }, [isControlled, handleOpen]);
  var onToggle = useCallback(function () {
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  }, [isOpen, onOpen, onClose]);
  function getButtonProps() {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread(_objectSpread({}, props2), {}, {
      "aria-expanded": isOpen,
      "aria-controls": id,
      onClick: function onClick(event) {
        var _a;
        (_a = props2.onClick) == null ? void 0 : _a.call(props2, event);
        onToggle();
      }
    });
  }
  function getDisclosureProps() {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread(_objectSpread({}, props2), {}, {
      hidden: !isOpen,
      id: id
    });
  }
  return {
    isOpen: isOpen,
    onOpen: onOpen,
    onClose: onClose,
    onToggle: onToggle,
    isControlled: isControlled,
    getButtonProps: getButtonProps,
    getDisclosureProps: getDisclosureProps
  };
}
export { useDisclosure };